import { WebPlugin } from '@capacitor/core';
export class FileSharerWeb extends WebPlugin {
    async echo(options) {
        console.log('ECHO', options);
        return options;
    }
    async share() {
        throw this.unavailable('FileSharer API not available in this browser.');
    }
    async shareMultiple() {
        throw this.unavailable('FileSharer API not available in this browser.');
    }
}
//# sourceMappingURL=web.js.map